import { isSessionEstablished } from '@mgo/core/src/sessionState';

export const sessionUnavailableRedirect = (to) => {
  if (to.name === 'session-unavailable' || isSessionEstablished()) {
    return null;
  }

  return { name: 'session-unavailable' };
};

export default sessionUnavailableRedirect;
